import { FC } from 'react';
import ThreadedCommentsContent from './ThreadedCommentsContent';
import { type ThreadedComment } from './threadedComments';

interface Props {
  comments: ThreadedComment[];
  contentType: number;
  objectId: number;
}

const noopCommentsChange = () => {};

const ThreadedCommentsPreview: FC<Props> = ({
  comments,
  contentType,
  objectId,
}) => {
  return (
    <ThreadedCommentsContent
      comments={comments}
      onCommentsChange={noopCommentsChange}
      contentType={contentType}
      objectId={objectId}
      variant="popover"
    />
  );
};

export default ThreadedCommentsPreview;
